class TestInstanceHolder {
  instances = {}

  register(key, instance) {
    this.instances[key] = instance
  }

  get(key) {
    return this.instances[key]
  }

  clear() {
    this.instances = {}
  }
}

export const testInstanceHolder = new TestInstanceHolder()
